import { FC, HTMLAttributes } from 'react';

import Close from '@/assets/icons/Close';

import styles from './SidepanelClose.module.css';

type SidepanelCloseProps = {
  close: (() => void) | (() => Promise<void>);
};
const SidepanelClose: FC<SidepanelCloseProps & HTMLAttributes<HTMLAnchorElement>> = ({ close, ...divProps }) => {
  return (
    <a
      data-testid='sidepanelClose'
      className={styles.closeDivStyle}
      onClick={close}
      onKeyDown={(event) => {
        if (event.key === 'Enter') close();
      }}
      style={{ textDecoration: 'none' }}
      {...divProps}
    >
      <Close className={styles.closeIconStyle} />
    </a>
  );
};
export default SidepanelClose;
